import { isServerSide } from 'src/utilities/isServerSide';
import { getWindow } from 'src/utilities/window';

export function isInternetExplorer(): boolean {
  const window = getWindow();
  return !isServerSide() && /Trident\/|MSIE/.test(window.navigator.userAgent);
}
